import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import React from 'react';

import HeadMeta from '#components/HeadMeta';
import { useTabletOrDesktop } from '#components/hooks/breakpoints';
import { Text, Title } from '#components/Typography';
import MainLayout from '#layout/MainLayout';

const { Panel } = Collapse;

const FAQS: NextPage = () => {
  const { t } = useTranslation('faqs');
  const isTabletOrDesktop = useTabletOrDesktop();

  return (
    <MainLayout footerVisible>
      <HeadMeta title={t('pageTitle')} />

      <div className="faqs px-24 py-32">
        <Title preset={isTabletOrDesktop ? 'bold40' : 'bold32'} className="text-center">
          {t('title.faqs')}
        </Title>

        <Text preset={isTabletOrDesktop ? 'regular18' : 'regular14'} className="block text-center md:max-w-768">
          <span dangerouslySetInnerHTML={{ __html: t('title.message') }} />
        </Text>

        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          className="mt-24 site-collapse-custom-collapse"
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key: number) => (
            <Panel key={key} header={t(`faqs.${key}.title`)} className="site-collapse-custom-panel">
              <div dangerouslySetInnerHTML={{ __html: t(`faqs.${key}.content`) }} />
            </Panel>
          ))}
        </Collapse>
      </div>
    </MainLayout>
  );
};

export default FAQS;
